export default __webpack_public_path__ + "static/media/covid-tracker.bcfad42b.png";